/* eslint-disable import/order */
import React from 'react';
import { MenuIdProfile } from '@jira/navigation-apps__constants/src/MenuIdProfile.tsx';
import { SidebarIdPersonalSettings } from '@jira/navigation-apps__constants/src/SidebarIdPersonalSettings.tsx';
import type GeneralPersonalSettingsType from '@jira/spa-apps__personal-settings-general/src/ExportedDefault.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { getNavigationForgePersonalSettingsPageResources } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { generalPersonalSettingsRoute } from '@jira/router-routes__personal-settings-routes/src/generalPersonalSettingsRoute.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import { getLabsResources } from './common/getLabsResources.tsx';
import type { Route } from '@atlassian/react-resource-router';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyGeneralPersonalSettings = lazyForPaint<typeof GeneralPersonalSettingsType>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-personal-settings-general", jiraSpaEntry: "async-personal-settings-general" */ '@jira/spa-apps__personal-settings-general/src/ExportedDefault.tsx'
			),
		),
	{
		ssr: false,
	},
);

const GeneralPersonalSettingsComponent = () => (
	<LazyPage
		Page={LazyGeneralPersonalSettings}
		pageId="personal-settings-general"
		shouldShowSpinner
	/>
);

export const generalPersonalSettingsRouteEntry: Route = createEntry(
	generalPersonalSettingsRoute,
	() => ({
		group: 'personal-settings',
		// eslint-disable-next-line no-restricted-syntax
		component: GeneralPersonalSettingsComponent,
		layout: globalLayout,

		navigation: {
			sidebarId: SidebarIdPersonalSettings,
			menuId: MenuIdProfile,
		},

		resources: [
			...getNavigationResources(),
			getConsolidationStateResource(),
			...getLabsResources(),
			...getNavigationForgePersonalSettingsPageResources(),
		],

		forPaint: [LazyAtlassianNavigation, LazyGeneralPersonalSettings],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
